<template>
	<div>
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div class="bg-white padding-xl">
			<Form ref="formConfig" :model="formConfig" label-position="right" :label-width="100" label-colon>
				<Divider orientation="left">首页轮换图</Divider>
				<div class="padding-tb">
					<div class="solid" style="width:750px; margin:0 auto 30px;">
						<Carousel autoplay v-model="value2" loop>
							<CarouselItem v-for="item in formConfig.banner">
								<div class="demo-carousel">
									<img :src="item.image" :alt="item.name" />
								</div>
							</CarouselItem>
						</Carousel>
					</div>

					<div class="padding-bottom">
						<Button type="primary" @click="showBannerAddModal()">添加</Button>
					</div>
					<Table :data="formConfig.banner" :columns="columnsBanner" border size="large">
						<template slot-scope="{ row, index }" slot="image">
							<div class="padding text-center">
								<img :src="$cfg.host + row.image" :alt="row.name" style="height:120px; border:#ddd 5px solid;" />
							</div>

						</template>
						<template slot-scope="{ row, index }" slot="state">
							<Tag color="success" v-if="row.viewflag">正常</Tag>
							<Tag color="error" v-else>隐藏</Tag>
						</template>
						<template slot-scope="{ row, index }" slot="action">
							<Button type="warning" @click="bannerModify(index)">
								修改
							</Button> &nbsp;
							<Button type="error" @click="delBanner(index)">
								删除
							</Button>
						</template>
					</Table>
				</div>
				<Row class-name="padding-tb-sm">
					<Col span="8">
					</Col>
					<Col span="8">
					</Col>
				</Row>
				<Divider orientation="left">弹窗广告</Divider>
				<div class="padding-xl">
					<FormItem label="启用状态">
						<i-switch v-model="formConfig.tc.viewflag" :true-value="1" :false-value="0">
							<span slot="open">显示</span>
							<span slot="close">隐藏</span>
						</i-switch>
					</FormItem>
					<FormItem label="广告图片">
						<Upload ref="upload" name="file" :show-upload-list="false" :on-success="uploadTcSuccess" :format="['jpg','jpeg','png']"
						 :max-size="2048" type="drag" :action="$cfg.host+'/server/api/upload.php?a=upload'" :data="{dir:'xcx'}" style="display: inline-block; line-height:0">
							<div class="demo-upload" v-if="formConfig.tc.image">
								<img :src="$cfg.host+formConfig.tc.image">
							</div>
							<div style="width: 58px;height:58px;line-height: 58px;" v-else>
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
					</FormItem>
					<FormItem label="链接页面">
						<Input v-model="formConfig.tc.url" maxlength="58"></Input>
					</FormItem>
				</div>
				<Divider orientation="left">首页导航</Divider>
				<div class="padding-tb">
					<div class="padding-bottom">
						<Button type="primary" @click="showNavAddModal()">添加</Button>
					</div>
					<Table :data="formConfig.nav" :columns="columnsNav" border size="large">
						<template slot-scope="{ row, index }" slot="image">
							<div class="padding text-center">
								<img :src="$cfg.host + row.image" :alt="row.name" style="height:64px; border:#ddd 5px solid;" />
							</div>

						</template>
						<template slot-scope="{ row, index }" slot="state">
							<Tag color="success" v-if="row.viewflag">正常</Tag>
							<Tag color="error" v-else>隐藏</Tag>
						</template>
						<template slot-scope="{ row, index }" slot="action">
							<Button type="warning" @click="navModify(index)">
								修改
							</Button> &nbsp;
							<Button type="error" @click="delNav(index)">
								删除
							</Button>
						</template>
					</Table>
				</div>
				<Divider />
				<FormItem>
					<Button type="primary" @click="submitModify('formConfig')">保存</Button>
				</FormItem>
			</Form>
		</div>
		<Modal v-model="modalBannerAddShow" title="添加首页轮换图" :mask-closable="false" footer-hide :width="520">
			<div style="position: relative;" class="padding-left padding-right-xl">
				<Form ref="formBannerAdd" :model="formBannerAdd" label-position="right" :label-width="100" label-colon>
					<FormItem label="名称">
						<Input v-model="formBannerAdd.name" maxlength="18"></Input>
					</FormItem>
					<FormItem label="图片" required>
						<Upload ref="upload" name="file" :show-upload-list="false" :on-success="uploadBannerSuccess" :format="['jpg','jpeg','png']"
						 :max-size="2048" type="drag" :action="$cfg.host+'/server/api/upload.php?a=upload'" :data="{dir:'xcx'}" style="display: inline-block; line-height:0">
							<div class="demo-upload" v-if="formBannerAdd.image">
								<img :src="$cfg.host+formBannerAdd.image">
							</div>
							<div style="width: 58px;height:58px;line-height: 58px;" v-else>
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
					</FormItem>
					<FormItem label="显示">
						<i-switch v-model="formBannerAdd.viewflag" :true-value="1" :false-value="0">
							<span slot="open">显示</span>
							<span slot="close">隐藏</span>
						</i-switch>
					</FormItem>
					<FormItem label="链接页面">
						<Input v-model="formBannerAdd.url" maxlength="58"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="formSubmitBannerAdd('formBannerAdd')">提交</Button>
						<Button style="margin-left: 8px" @click="modalBannerAddShow=false">取消</Button>
					</FormItem>
				</Form>
			</div>
		</Modal>
		<Modal v-model="modalBannerModifyShow" title="修改首页轮换图" :mask-closable="false" footer-hide :width="520">
			<div style="position: relative;" class="padding-left padding-right-xl">
				<Form ref="formBannerAdd" :model="formBannerModify" label-position="right" :label-width="100" label-colon>
					<FormItem label="名称">
						<Input v-model="formBannerModify.name" maxlength="18"></Input>
					</FormItem>
					<FormItem label="图片" required>
						<Upload ref="upload" name="file" :show-upload-list="false" :on-success="uploadBannerSuccessModify" :format="['jpg','jpeg','png']"
						 :max-size="2048" type="drag" :action="$cfg.host+'/server/api/upload.php?a=upload'" :data="{dir:'xcx'}" style="display: inline-block; line-height:0">
							<div class="demo-upload" v-if="formBannerModify.image">
								<img :src="$cfg.host+formBannerModify.image">
							</div>
							<div style="width: 58px;height:58px;line-height: 58px;" v-else>
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
					</FormItem>
					<FormItem label="显示">
						<i-switch v-model="formBannerModify.viewflag" :true-value="1" :false-value="0">
							<span slot="open">显示</span>
							<span slot="close">隐藏</span>
						</i-switch>
					</FormItem>
					<FormItem label="链接页面">
						<Input v-model="formBannerModify.url" maxlength="58"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="formSubmitBannerModify('formBannerModify')">提交</Button>
						<Button style="margin-left: 8px" @click="modalBannerModifyShow=false">取消</Button>
					</FormItem>
				</Form>
			</div>
		</Modal>
		<Modal v-model="modalNavAddShow" title="添加首页导航" :mask-closable="false" footer-hide :width="520">
			<div style="position: relative;" class="padding-left padding-right-xl">
				<Form ref="formNavAdd" :model="formNavAdd" label-position="right" :label-width="100" label-colon>
					<FormItem label="名称" required>
						<Input v-model="formNavAdd.name" maxlength="18"></Input>
					</FormItem>
					<FormItem label="图标" required>
						<Upload ref="upload" name="file" :show-upload-list="false" :on-success="uploadNavSuccess" :format="['jpg','jpeg','png']"
						 :max-size="2048" type="drag" :action="$cfg.host+'/server/api/upload.php?a=upload'" :data="{dir:'xcx'}" style="display: inline-block; line-height:0">
							<div class="demo-upload" v-if="formNavAdd.image">
								<img :src="$cfg.host+formNavAdd.image">
							</div>
							<div style="width: 58px;height:58px;line-height: 58px;" v-else>
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
					</FormItem>
					<FormItem label="显示">
						<i-switch v-model="formNavAdd.viewflag" :true-value="1" :false-value="0">
							<span slot="open">显示</span>
							<span slot="close">隐藏</span>
						</i-switch>
					</FormItem>
					<FormItem label="链接页面" required>
						<Input v-model="formNavAdd.url" maxlength="58"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="formSubmitNavAdd('formNavAdd')">提交</Button>
						<Button style="margin-left: 8px" @click="modalNavAddShow=false">取消</Button>
					</FormItem>
				</Form>
			</div>
		</Modal>
		<Modal v-model="modalNavModifyShow" title="修改首页导航" :mask-closable="false" footer-hide :width="520">
			<div style="position: relative;" class="padding-left padding-right-xl">
				<Form ref="formNavModify" :model="formNavModify" label-position="right" :label-width="100" label-colon>
					<FormItem label="名称" required>
						<Input v-model="formNavModify.name" maxlength="18"></Input>
					</FormItem>
					<FormItem label="图标" required>
						<Upload ref="upload" name="file" :show-upload-list="false" :on-success="uploadNavSuccessModify" :format="['jpg','jpeg','png']"
						 :max-size="2048" type="drag" :action="$cfg.host+'/server/api/upload.php?a=upload'" :data="{dir:'xcx'}" style="display: inline-block; line-height:0">
							<div class="demo-upload" v-if="formNavModify.image">
								<img :src="$cfg.host+formNavModify.image">
							</div>
							<div style="width: 58px;height:58px;line-height: 58px;" v-else>
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
					</FormItem>
					<FormItem label="显示">
						<i-switch v-model="formNavModify.viewflag" :true-value="1" :false-value="0">
							<span slot="open">显示</span>
							<span slot="close">隐藏</span>
						</i-switch>
					</FormItem>
					<FormItem label="链接页面" required>
						<Input v-model="formNavModify.url" maxlength="58"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="formSubmitNavModify('formNavModify')">提交</Button>
						<Button style="margin-left: 8px" @click="modalNavModifyShow=false">取消</Button>
					</FormItem>
				</Form>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				formConfig: {
					banner: [],
					tc: {
						image: '',
						viewflag: 1
					},
					nav: []
				},
				columnsBanner: [{
						title: 'id',
						type: 'index',
						width: 58
					},
					{
						title: '名称',
						align: 'center',
						key: 'name'
					},
					{
						title: '图片',
						align: 'center',
						slot: 'image'
					},
					{
						title: '链接页面',
						align: 'center',
						key: 'url'
					},
					{
						title: '显示状态',
						align: 'center',
						slot: 'state'
					},
					{
						title: '操作',
						align: 'center',
						slot: 'action'
					}
				],
				modalBannerAddShow: false,
				formBannerAdd: {
					image: '',
					viewflag: 1
				},
				modalBannerModifyShow: false,
				formBannerModify: {},
				columnsNav: [{
						title: 'id',
						type: 'index',
						width: 58
					},
					{
						title: '名称',
						align: 'center',
						key: 'name'
					},
					{
						title: '图标',
						align: 'center',
						slot: 'image'
					},
					{
						title: '链接页面',
						align: 'center',
						key: 'url'
					},
					{
						title: '显示状态',
						align: 'center',
						slot: 'state'
					},
					{
						title: '操作',
						align: 'center',
						slot: 'action'
					}
				],
				modalNavAddShow: false,
				formNavAdd: {
					name: '',
					image: '',
					viewflag: 1,
					url: ''
				},
				modalNavModifyShow: false,
				formNavModify: {}
			};
		},
		methods: {
			loadinfo() {
				this.loading = true;
				this.$http.post('/server/api/client/config.php?a=init').then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.formConfig = res.data.data.info;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.$Message.error('系统错误');
					}
				);
			},
			showBannerAddModal() {
				this.formBannerAdd = {
					name: '',
					image: '',
					viewflag: 1
				};
				this.modalBannerAddShow = true;
			},
			uploadBannerSuccess(res, file, fileList) {
				this.formBannerAdd.image = res.data.url;
			},
			formSubmitBannerAdd(name) {
				if (!this.formBannerAdd.image) {
					this.$Message.error('请上传图片');
					return false;
				}
				this.formConfig.banner.push(this.formBannerAdd);
				this.modalBannerAddShow = false;
			},
			bannerModify(idx) {
				this.modalBannerModifyShow = true;
				this.formBannerModify = this.formConfig.banner[idx];
				this.formBannerModify.idx = idx;
			},
			uploadBannerSuccessModify(res, file, fileList) {
				this.formBannerModify.image = res.data.url;
			},
			formSubmitBannerModify(name) {
				if (!this.formBannerModify.image) {
					this.$Message.error('请上传图片');
					return false;
				}
				this.formConfig.banner[this.formBannerModify.idx] = this.formBannerModify;
				this.modalBannerModifyShow = false;
				this.formBannerModify = {
					viewflag: 1
				};
			},
			delBanner(idx) {
				this.formConfig.banner.splice(idx, 1);
			},
			uploadTcSuccess(res, file, fileList) {
				this.formConfig.tc.image = res.data.url;
			},
			showNavAddModal() {
				this.formNavAdd = {
					name: '',
					image: '',
					viewflag: 1
				};
				this.modalNavAddShow = true;
			},
			uploadNavSuccess(res, file, fileList) {
				this.formNavAdd.image = res.data.url;
			},
			formSubmitNavAdd(name) {
				if (!this.formNavAdd.image) {
					this.$Message.error('请上传图片');
					return false;
				}
				if (!this.formNavAdd.url) {
					this.$Message.error('请填写链接地址');
					return false;
				}
				this.formConfig.nav.push(this.formNavAdd);
				this.modalNavAddShow = false;
			},
			navModify(idx) {
				this.modalNavModifyShow = true;
				this.formNavModify = this.formConfig.nav[idx];
				this.formNavModify.idx = idx;
			},
			uploadNavSuccessModify(res, file, fileList) {
				this.formNavModify.image = res.data.url;
			},
			formSubmitNavModify(name) {
				if (!this.formNavModify.image) {
					this.$Message.error('请上传图片');
					return false;
				}
				if (!this.formNavModify.url) {
					this.$Message.error('请填写链接地址');
					return false;
				}
				this.formConfig.nav[this.formNavModify.idx] = this.formNavModify;
				this.modalNavModifyShow = false;
				this.formNavModify = {
					viewflag: 1
				};
			},
			delNav(idx) {
				this.formConfig.nav.splice(idx, 1);
			},
			submitModify(name) {
				this.loading = true;
				this.$http.post('/server/api/client/config.php?a=save', this.$qs.stringify({
					data: this.formConfig
				})).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							this.$Message.success('操作成功!');
							this.loadinfo();
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			}
		},
		created() {
			this.loadinfo();
		}
	};
</script>

<style>
	img {
		display: block;
	}

	.imgbox {
		border: #ddd 1px solid;
		box-shadow: #aaa 0 0 8px;
	}

	.demo-spin-icon-load {
		animation: ani-demo-spin 1s linear infinite;
	}

	.demo-upload {
		display: inline-block;
		border: 1px solid #eee;
		border-radius: 4px;
		overflow: hidden;
		background: #f5f5f5;
		padding: 4px;
	}

	.demo-upload img {
		height: 120px;
		width: auto;
		display: block;
	}
</style>
